'use strict';

/*global app*/
/*global services*/
/*global sprintf*/
/*global isEmpty*/
/*global parseFloatK2*/
/*global invokeCallback*/
/*global resSuccess*/
/*global resError*/
/*global weightNetto*/
/*global weightBrutto*/

function ArticleService() {
  this.$container = null;

  this.init();
}

ArticleService.prototype = $.extend({}, {
  constructor: 'ArticleService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$container.on('click', '.article__add-to-filter', function () {
      _this.addToFilter($(this).data('article_id'));

      return false;
    });

    _this.$container.on('click', '.article__print', function () {
      _this.print($(this).data('article_id'), $(this).data('type'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  get: function get(articleId, callback) {
    var _this = this;

    app.getFormation('article:get', { ArticleId: articleId }, function (res) {
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, res.data);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  getWeight: function getWeight(weightType, data, callback) {
    var _this = this;

    var weight = 0;
    var translation = app.t('article.change_weight');

    switch (weightType) {
      case weightNetto : {
        weight = data.NettoWeight;
        translation = app.t('article.change_weight_netto');
      }

      break;
      case weightBrutto : {
        weight = data.GrossWeight;
        translation = app.t('article.change_weight_brutto');
      }

      break;
    }

    app.getValue({ content: sprintf(translation, data.Name, weight), suffix: app.t('weigth_per_pcs') }, function (value) {
      if (isEmpty(value)) {
        return invokeCallback(callback, false);
      }

      value = parseFloatK2(value);
      if (value > 0) {
        return invokeCallback(callback, value);
      }

      _this.getWeight(weightType, data, callback);
    });

    return _this;
  },

  saveWeight: function saveWeight(articleId, weightType, weight, callback) {
    var _this = this;

    app.getFormation('article:save_weight', { ArticleId: articleId, WeightType: weightType, Weight: weight }, function (res) {
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, weight);
      } else {
        app.viewErrorMessage(res.error);

        invokeCallback(callback, -1);
      }
    });

    return _this;
  },

  changeWeight: function changeWeight(articleId, weightType, callback) {
    var _this = this;

    _this.get(articleId, function (data) {
      _this.getWeight(weightType, data, function (weight) {
        if (weight !== false) {
          _this.saveWeight(articleId, weightType, weight, callback);
        } else {
          invokeCallback(callback, -1);
        }
      });
    });

    return _this;
  },

  saveEan: function saveEan(articleId, ean, callback) {
    var _this = this;

    app.getFormation('article:save_barcode', { article_id: articleId, barcode: ean }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewSuccessMessage();

        invokeCallback(callback, ean);
      } else {
        app.viewErrorMessage(res.error);

        invokeCallback(callback);
      }
    });

    return _this;
  },

  addEan: function addEan(articleId, callback) {
    var _this = this;

    _this.get(articleId, function (data) {
      services.get('barcode-service').scanBarcode(data.Name, function (res, ean) {
        if (res === resSuccess) {
          _this.saveEan(articleId, ean, callback);
        } else {
          invokeCallback(callback);
        }
      });
    });

    return _this;
  },

  getStockQuantity: function getStockQuantity(id, params, callback) {
    var _this = this;

    params.Id = id;

    app.getFormation('article:get_stock_quantity', params, function (res) {
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, resSuccess, res.data);
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback, resError);
        });
      }
    });

    return _this;
  },

  addToFilter: function addToFilter(articleId) {
    var _this = this;

    app.getFormation('article:add_to_filter', { ArticleId: articleId, WarehouseId: app.param('active_warehouse_id') }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewSuccessMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  print: function print(articleId, type) {
    var _this = this;

    services.get('printing-service').printArticle(articleId, type);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('body');

    _this.registerCallbacks();

    return _this;
  }
});
